import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError, retry } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { MeasureRequest } from '../../requests/sync-measurer/measure.request';
import { GetSyncMeasurerResponse } from '../../responses/sync-measurer/get-sync-measurer.response';


@Injectable({
  providedIn: 'root'
})
export class SyncMeasureService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient,) {
    super();
  }

  public getSyncMeasurer(syncMeasurerhash: string): Observable<GetSyncMeasurerResponse> {

    let url = `SyncMeasurerHash?syncMeasurerhash=${syncMeasurerhash}`

    return this.httpClient.get<GetSyncMeasurerResponse>(environment.urlApiSyncMeasurer + url, this.addHeaderHash())
      .pipe(
        catchError(this.handleError)
      )
  }
}
